module.exports = __webpack_public_path__ + "img/3.full.99bd54cc.webp";